type Props = {
  modelName?: string;
  features?: string[];
  beds?: number;
  baths?: number;
  squareFeet?: number;
};

export function getMarketingParagraph({
  modelName,
  features,
  beds,
  baths,
  squareFeet,
}: Props): string {
  const hasFeatures = features?.length;
  const hasBedBathSqFt = beds && baths && squareFeet;

  if (!modelName || (!hasFeatures && !hasBedBathSqFt)) {
    return '';
  }

  let featuresSentence = '';
  if (hasFeatures) {
    const featLower = features.map((x) => x.toLowerCase());
    if (featLower.length === 1) {
      featuresSentence = ` Enjoy the ${featLower[0]} feature.`;
    } else if (featLower.length === 2) {
      featuresSentence = ` Enjoy features like ${featLower[0]} and ${featLower[1]}.`;
    } else {
      featuresSentence = ` Enjoy features like ${featLower[0]}, ${featLower[1]} and ${featLower[2]}.`;
    }
  }

  let bedBathsSentence = '';
  if (hasBedBathSqFt) {
    bedBathsSentence = ` This attainably priced home is great for households looking for ${beds} bed${beds > 1 ? 's' : ''} and ${baths} bath${baths > 1 ? 's' : ''} homes around ${squareFeet} square feet.`;
  }

  const modelContainsThe = modelName.toLowerCase().startsWith('the');
  return (
    `Explore the spacious, stylish and open floor plan of ${modelContainsThe ? modelName : 'the ' + modelName}.` +
    featuresSentence +
    bedBathsSentence
  );
}
